import {IssueGroupingKey, usePlantStoppages} from '@domain/stoppages'
import {DataContentWrapper} from '@hconnect/common/containers'
import {PageContainer} from '@hconnect/uikit/src/lib2'
import {useNavigate, useParams} from 'react-router'

import {DOWNTIME_STATISTICS_PATH, DOWNTIME_STOPPAGE_DETAILS_FOR_CODE_PATH} from '../consts'
import {DefaultStoppageDetails, EquipmentStoppageDetails} from '../containers'
import {useDowntimePlantId} from '../providers'

type PathParameter = {
  groupId: string
  groupType: IssueGroupingKey
}

export const DowntimeStoppagesDetails = () => {
  const plantId = useDowntimePlantId()
  const {groupType, groupId} = useParams<PathParameter>()
  if (!groupId || !groupType) throw new Error('Missing stoppage group prop')
  const navigate = useNavigate()

  const {
    data: stoppageConfig,
    isInitialLoading,
    isError,
    refetch,
    isRefetching
  } = usePlantStoppages(plantId)

  const isEquipmentGroup =
    groupType === IssueGroupingKey.EQUIPMENT_NUMBER ||
    groupType === IssueGroupingKey.MAIN_EQUIPMENT ||
    groupType === IssueGroupingKey.STOPPED_MAIN_EQUIPMENT

  return (
    <PageContainer>
      <DataContentWrapper
        showLoader={isInitialLoading}
        data={stoppageConfig}
        retryFunction={() => void refetch()}
        isRefetching={isRefetching}
        isError={isError}
      >
        {isEquipmentGroup ? (
          <EquipmentStoppageDetails
            stoppageConfig={stoppageConfig}
            backToStoppagesBasePath={'../..'}
            downtimeStoppageDetailsForCodeBasePath={DOWNTIME_STOPPAGE_DETAILS_FOR_CODE_PATH}
            onShowKilnStatsClick={() =>
              void navigate(`../../../${DOWNTIME_STATISTICS_PATH}`, {relative: 'path'})
            }
          />
        ) : (
          <DefaultStoppageDetails
            stoppageConfig={stoppageConfig}
            backToStoppagesBasePath={'../..'}
          />
        )}
      </DataContentWrapper>
    </PageContainer>
  )
}
